import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { fetchReasons } from "../Services/APIService";
import CreateReason from "../Components/CreateReason";
import ReasonsView from "../Components/ReasonsView";
import UpdateReason from "../Components/UpdateReason";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import { useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import OverlayLoader from "../Components/OverlayLoader";

interface MenuItem {
  menuID: number;
  menuName: string;
  menuUrl: string;
  icon: string;
  subMenuList?: [];
}

export interface ReasonData {
  id: number;
  typeId: number;
  typeName: string;
  description: string;
  isActive: boolean;
}

const Reasons: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [allowedMenus, setAllowedMenus] = useState<MenuItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showCreateCard, setShowCreateCard] = useState(false);
  const [showUpdateCard, setShowUpdateCard] = useState(false);
  const [selectedViewData, setselectedViewData] = useState<ReasonData | null>(null);
  const [viewdatas, setviewdatas] = useState<ReasonData[]>([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const location = useLocation();

  const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);

  const toggleCreateForm = () => {
    setShowCreateCard(!showCreateCard);
    if (showUpdateCard) {
      setShowUpdateCard(false);
      setselectedViewData(null);
    }
  };

  const handleEdit = (data: ReasonData) => {
    setselectedViewData(data);
    setShowUpdateCard(true);
    if (showCreateCard) setShowCreateCard(false);
    setTimeout(() => {
      const updateCard = document.getElementById("updateGroupCard");
      if (updateCard) updateCard.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const handleCreateComplete = () => {
    setShowCreateCard(false);
    refreshGroups();
  };

  const handleCreateCancel = () => setShowCreateCard(false);

  const handleUpdateComplete = () => {
    setShowUpdateCard(false);
    setselectedViewData(null);
    refreshGroups();
  };

  const handleUpdateCancel = () => {
    setShowUpdateCard(false);
    setselectedViewData(null);
  };

  const refreshGroups = () => setRefreshTrigger((prev) => prev + 1);

  // Fetch menu data
  useEffect(() => {
    const getMenus = async () => {
      setIsLoading(true);
      try {
        const menuID = location.state?.menuID;
        const previousMenuID = localStorage.getItem("activeMenuID");
        if (menuID !== previousMenuID || menuID === null) {
          localStorage.setItem("activeMenuID", menuID);
        } else {
          localStorage.removeItem("activeMenuID");
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        setIsLoading(false);
      }
    };
    getMenus();
  }, []);

  // Fetch reasons data
  useEffect(() => {
    const getReasons = async () => {
      try {
        const tenantId = Number(localStorage.getItem("tenantId")); // 👈 adjust key if different
        const fetchViewData = await fetchReasons(tenantId);
        const mapped: ReasonData[] = fetchViewData.map((item: any) => ({
          id: item.id,
          typeId: item.typE_ID,
          description: item.description,
          isActive: item.iS_ACTIVE,
          tenantId: item.tenanT_ID,
          createdBy: item.createD_BY,
          createdOn: item.createD_ON,
          modifiedBy: item.modifieD_BY ?? null,
          modifiedOn: item.modifieD_ON ?? null,
        }));
        setviewdatas(mapped);
      } catch (error) {
        console.error("Error fetching reasons:", error);
      }
    };
    getReasons();
  }, [refreshTrigger]);

  return (
    <div className="wrapper">
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <div>
          <Toaster
            position="top-center"
            reverseOrder={false}
            containerStyle={{ zIndex: 10000 }}
          />
        </div>
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-12 col-lg-12">
                  {showCreateCard && (
                    <CreateReason
                      onCreateComplete={handleCreateComplete}
                      onCancel={handleCreateCancel}
                    />
                  )}
                  {showUpdateCard && (
                    <div id="updateGroupCard">
                      <UpdateReason
                         viewData={selectedViewData as any}
                        onUpdateComplete={handleUpdateComplete}
                        onCancel={handleUpdateCancel}
                      />
                    </div>
                  )}
                </div>
                <div className="col-12 col-lg-12">
                  <ReasonsView
                    viewData={viewdatas}
                    onEdit={handleEdit}
                    onAddClick={toggleCreateForm}
                    showAddButton={!showCreateCard && !showUpdateCard}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
        <Footer />
      </div>
      <OverlayLoader
        loading={isLoading}
        message="Loading Reasons Data"
        submessage="This might take a moment..."
      />
    </div>
  );
};

export default Reasons;